import React from 'react';

class ValidationError extends React.Component {

	getMessage = () => {
		var message = "";

		if (this.props.message !== undefined) {
			message = this.props.message;
		}
		else if (this.props.error !== undefined && this.props.error !== null && this.props.error.errorMessage !== undefined) {
			message = this.props.error.errorMessage;
		}

		return message;
	}

	render() {
		return (
			<React.Fragment>
				{this.getMessage() !== "" &&
					<div className="alert alert-danger">
						<div dangerouslySetInnerHTML={{ __html: this.getMessage() }} />
					</div>
				}
			</React.Fragment>
		)
	}
}

export default ValidationError;



// WEBPACK FOOTER //
// ./src/fw/components/validationError/ValidationError.js